/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Italics_LabelInputs */



/**
* | output |
* | --- |
* | "Italics" |
*
* @param {Style_Guide_Manager_Italics_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_italics_label = /** @type {((inputs?: Style_Guide_Manager_Italics_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Italics_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Italique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kursivschrift")
	if (locale === "it") return /** @type {LocalizedString} */ ("Corsivo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Курсив")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cursiva")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("斜体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イタリック体")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तिर्छा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Itálico")
	return /** @type {LocalizedString} */ ("Italics")
});